// Action Types
export const FETCH_CATEGORIES_STARTED = "FETCH_CATEGORIES_STARTED";
export const FETCH_CATEGORIES_SUCCESS = "FETCH_CATEGORIES_SUCCESS";
export const FETCH_CATEGORIES_ERROR = "FETCH_CATEGORIES_ERROR";
export const SET_CURRENT_CATEGORY_ID = "SET_CURRENT_CATEGORY_ID";
export const SET_SUB_CATEGORIES_STATUS = "SET_SUB_CATEGORIES_STATUS";
export const SET_MENU_CATEGORY_ID = "SET_MENU_CATEGORY_ID";
// Data types
export interface Post {
    id: number
    title: string
}
export interface Form {
    id: number
    title: string
}
export interface Category {
    id: number
    title: string
    icon?: string
    children: number[]
    parent?: number
    posts: Post[]
    forms: Form[]
};
//Reducer State Type
export interface CategoriesState {
    items: any
    parents: number[]
    error: any
    isFetching: boolean
    isSubCategoriesOpen: boolean
    currentCategoryId: number
    menuCategoryId: number
}
// Action Data Types
export interface FetchCategoriesActionStarted {
    type: typeof FETCH_CATEGORIES_STARTED
}
export interface FetchCategoriesActionSuccess {
    type: typeof FETCH_CATEGORIES_SUCCESS
    categories  : any
    parents     : number[]
}
export interface FetchCategoriesActionError {
    type: typeof FETCH_CATEGORIES_ERROR
    error: any
}
export interface SetCurrentCategoryIdAction{
    type: typeof SET_CURRENT_CATEGORY_ID
    currentCategoryId: number
}
export interface SetMenuCategoryIdAction{
    type: typeof SET_MENU_CATEGORY_ID
    categoryId: number
}
export interface ToggleSubCategoriesAction {
    type: typeof SET_SUB_CATEGORIES_STATUS
    open: boolean
}
export type FetchCategoriesActionTypes = FetchCategoriesActionStarted | FetchCategoriesActionSuccess | FetchCategoriesActionError;
export type SetCurrentCategoryIdActionType = SetCurrentCategoryIdAction | SetMenuCategoryIdAction
export type ToggleSubCategoriesActionType = ToggleSubCategoriesAction